import React, { useCallback } from "react";
import { useCart } from "../../context/CartContext";
import { Link } from "react-router-dom";

function CartItemsInCart({ item }) {
  const { updateQuantity, removeItem } = useCart();

  const {
    _id,
    thumbnail: image,
    slug,
    title,
    variantName,
    quantity,
    price,
    subtotal,
    mrp,
  } = item;

  const numPrice = Number(price);
  const numMrp = Number(mrp);

  const handleRemove = useCallback(() => {
    removeItem(item._id);
  }, [removeItem, item._id]);

  const handleQuantityChange = useCallback(
    (delta) => {
      const newQuantity = quantity + delta;
      if (newQuantity < 1) return;
      updateQuantity(_id, newQuantity);
    },
    [updateQuantity, _id, quantity]
  );

  return (
    <>
      {/* ================= Desktop ================= */}
      <tr className="hidden md:table-row border-b border-[#eee7df] last:border-none">
        <td className="py-4 pr-4">
          <div className="flex items-center gap-4">
            <Link
              to={slug}
              className="w-16 h-16 rounded-xl overflow-hidden bg-[#fbf9f6] border border-[#eee7df] flex-shrink-0"
            >
              <img
                src={image}
                alt={title}
                className="w-full h-full object-cover"
              />
            </Link>

            <div>
              <Link
                to={slug}
                className="custom-cart-btn text-sm font-medium text-[#181512] hover:text-[#a63c06] transition-colors line-clamp-1"
              >
                {title}
              </Link>

              <div className="text-xs text-[#9a9188] mt-0.5">
                {variantName}
              </div>

              <button
                onClick={handleRemove}
                className="text-xs text-[#a63c06] hover:underline mt-1 block"
              >
                Remove
              </button>
            </div>
          </div>
        </td>

        <td className="py-4 text-center">
          {!isNaN(numMrp) && numMrp > numPrice && (
            <span className="text-xs text-[#9a9188] line-through">
              ₹{numMrp.toFixed(2)}
            </span>
          )}
        </td>

        <td className="py-4 text-center">
          <span className="text-sm font-medium text-[#181512]">
            ₹{numPrice.toFixed(2)}
          </span>
        </td>

        <td className="py-4 text-center">
          <div className="inline-flex items-center border border-[#eee7df] rounded-lg bg-[#fbf9f6]">
            <button
              className="px-2.5 py-1 text-xs text-[#5e564f] hover:text-[#a63c06]"
              onClick={() => handleQuantityChange(-1)}
            >
              -
            </button>

            <input
              className="w-8 text-center text-xs bg-transparent font-medium text-[#181512] focus:outline-none"
              type="text"
              value={quantity}
              readOnly
            />

            <button
              className="px-2.5 py-1 text-xs text-[#5e564f] hover:text-[#a63c06]"
              onClick={() => handleQuantityChange(+1)}
            >
              +
            </button>
          </div>
        </td>

        <td className="py-4 text-center">
          <span className="text-sm font-semibold text-[#181512]">
            ₹{subtotal.toFixed(2)}
          </span>
        </td>
      </tr>

      {/* ================= Mobile ================= */}
      <div className="md:hidden border-b border-[#eee7df] last:border-none py-4">
        <div className="flex items-start gap-3">

          {/* Image */}
          <Link
            to={slug}
            className="w-16 h-16 xs:w-[68px] xs:h-[68px] sm:w-20 sm:h-20 rounded-xl overflow-hidden bg-[#fbf9f6] border border-[#eee7df] flex-shrink-0"
          >
            <img
              src={image}
              alt={title}
              className="w-full h-full object-cover"
            />
          </Link>

          {/* Right Side */}
          <div className="flex-1 min-w-0">

            {/* Title */}
            <Link
              to={slug}
              className="block text-sm sm:text-base font-medium text-[#181512] leading-5 break-words line-clamp-2"
            >
              {title}
            </Link>

            {/* Variant */}
            <div className="text-xs text-[#9a9188] mt-1 break-words">
              {variantName}
            </div>

            {/* Price */}
            <div className="flex flex-wrap items-center gap-2 mt-2">
              <span className="text-sm font-medium text-[#181512]">
                ₹{numPrice.toFixed(2)}
              </span>

              {!isNaN(numMrp) && numMrp > numPrice && (
                <span className="text-xs text-[#9a9188] line-through">
                  ₹{numMrp.toFixed(2)}
                </span>
              )}
            </div>

            {/* Bottom */}
            <div className="mt-3 flex items-center justify-between gap-3">

              {/* Quantity */}
              <div className="inline-flex items-center border border-[#eee7df] rounded-lg bg-[#fbf9f6] flex-shrink-0">
                <button
                  className="px-2 sm:px-2.5 py-1 text-xs text-[#5e564f] hover:text-[#a63c06]"
                  onClick={() => handleQuantityChange(-1)}
                >
                  -
                </button>

                <input
                  className="w-7 sm:w-8 text-center text-xs bg-transparent font-medium text-[#181512] focus:outline-none"
                  type="text"
                  value={quantity}
                  readOnly
                />

                <button
                  className="px-2 sm:px-2.5 py-1 text-xs text-[#5e564f] hover:text-[#a63c06]"
                  onClick={() => handleQuantityChange(+1)}
                >
                  +
                </button>
              </div>

              {/* Remove */}
              <button
                onClick={handleRemove}
                className="text-xs sm:text-sm text-[#a63c06] hover:underline whitespace-nowrap"
              >
                Remove
              </button>
            </div>

            {/* Subtotal */}
            <div className="mt-3 text-right">
              <span className="text-sm font-semibold text-[#181512]">
                Total : ₹{subtotal.toFixed(2)}
              </span>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default CartItemsInCart;